import { Box, Button, Stack, Typography, Paper } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import RefreshIcon from '@mui/icons-material/Refresh'
import type { FallbackProps } from 'react-error-boundary'

export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => (
  <Box
    sx={{
      minHeight: '70vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2,
    }}
  >
    <Paper elevation={3} sx={{ p: 4, maxWidth: 520, width: '100%', borderRadius: 3 }}>
      <Stack spacing={2} alignItems="center" textAlign="center">
        <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main' }} />
        <Typography variant="h5" fontWeight={700}>
          Something went wrong
        </Typography>
        <Typography variant="body2" color="text.secondary">
          An unexpected error occurred. Our team has been notified.
        </Typography>
        {import.meta.env.DEV && (
          <Box
            sx={{
              width: '100%',
              p: 1.5,
              borderRadius: 1,
              bgcolor: 'action.hover',
              fontFamily: 'monospace',
              fontSize: 12,
              textAlign: 'left',
              wordBreak: 'break-word',
            }}
          >
            {error.message}
          </Box>
        )}
        <Button variant="contained" startIcon={<RefreshIcon />} onClick={resetErrorBoundary}>
          Try again
        </Button>
      </Stack>
    </Paper>
  </Box>
)
